<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <h4 class="color-secundary">Disponible con corte a: {{ fechaCorte }}</h4>
      <br />

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        :dataLength="dataLength"
        :perPage="10000"
        pagination
      >
        <table-column
          slot="label"
          :label="'Código'"
          showExportToExcel
          v-bind:value="'convenio'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Producto'"
          v-bind:value="'producto'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Porcentaje'"
          v-bind:value="'porcentaje_producto'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Porcentaje consumido'"
          v-bind:value="'porcentaje_calculado'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor neto disponible'"
          v-bind:value="'valor_neto'"
          :filter="'numberFormat'"
          :customClass="'text-center'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      fechaCorte: "",
      data: [],
      dataLength: 0,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    rows() {
      return this.data.length;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    async dataProcesada() {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await this.$store.state.api.get(
          "informes/riesgo_operativo/obtener_disponible",
          { params: { paginar: false } }
        );

        this.data = response.data.datos;
        this.dataLength = response.data.datos.length;
        this.$store.commit("SET_LOADING", false);
        return true;
      } catch (err) {
        this.$toasted.show(
          "Lo sentimos, ocurrió un error al intentar consultar los datos",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
        return false;
      }
    },
  },
  mounted() {
    this.dataProcesada();
    this.fechaCorte = this.$moment().format("YYYY-MM-DD");
  },
};
</script>